import { IncomingHttpHeaders } from 'http';
import React, { PropsWithChildren, useContext, useMemo } from 'react';

import getInternalHost from '../utils/getInternalHost';

interface Props {
  requestHeaders?: IncomingHttpHeaders;
  draft?: boolean;
}

interface ContextProps extends Props {
  internalHost: string;
}

export const RequestHeadersContext = React.createContext<ContextProps>({ draft: false, internalHost: '' });

const Provider = RequestHeadersContext.Provider;

export const RequestHeadersProvider: React.FC<PropsWithChildren<Props>> = ({ children, requestHeaders, draft }) => {
  const internalHost = useMemo(() => {
    return getInternalHost(requestHeaders);
  }, [requestHeaders]);

  return <Provider value={{ requestHeaders, draft, internalHost }}>{children}</Provider>;
};

export const useRequestHeaders = (): ContextProps => {
  const context = useContext(RequestHeadersContext);

  if (!context) {
    throw Error('The `useRequestHeaders` hook must be called from a descendent of the `RequestHeadersProvider`.');
  }

  return {
    ...context,
  };
};
